import { mentionTableRowExtension as BaseMentionTableRowExtension } from '@copera/tiptap/extensions';
import { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { memo, useCallback } from 'react';
import { MentionTableRowNodeView } from '../private/components/MentionTableRowNodeView';
import { getExtensionOption } from '../private/utils/getExtensionOption';

const TableRowLink = memo(({ node, editor }: NodeViewProps) => {
  const { rowId, tableId, boardId } = node.attrs;

  if (!rowId) return null;

  const onClick = useCallback(() => {
    const options = getExtensionOption(editor, 'mentionTableRow');
    options.onClick?.(rowId, boardId, tableId);
  }, [editor, rowId, boardId, tableId]);

  return (
    <NodeViewWrapper key={rowId} as="span">
      <MentionTableRowNodeView
        boardId={boardId}
        tableId={tableId}
        rowId={rowId}
        onClick={onClick}
      />
    </NodeViewWrapper>
  );
});

export const mentionTableRowExtended = BaseMentionTableRowExtension.extend({
  addCommandOption(this) {
    return [
      {
        title: 'Link a table row',
        description: 'Link an existing table row',
        searchTerms: ['link', 'table', 'row', 'task'],
        icon: 'tabler:table',
      },
    ];
  },
  addNodeView() {
    return ReactNodeViewRenderer(TableRowLink, {
      contentDOMElementTag: 'span',
    });
  },
});

export const mentionTableRowExtension = mentionTableRowExtended.configure();
